<template>
  <div class="home">
    <Cover :banners="banners.data" />
    <div ref="themeslayout" class="px-3 px-sm-0">
      <component v-for="(field,i) in fields " :is="field.section" :key="i"  :field="field"></component>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import Cover from '@/components/home/Cover.vue'
import SectionTitle from '@/components/home/SectionTitle.vue'
import Step from '@/components/home/Step.vue'
import ProductList1 from '@/components/home/ProductList1.vue'
import ProductList2 from '@/components/home/ProductList2.vue'
import ProductList3 from '@/components/home/ProductList3.vue'
import ProductList4 from '@/components/home/ProductList4.vue'

export default {
  name: 'home',
  components: {
    Cover,
    SectionTitle,
    ProductList1,
    ProductList2,
    ProductList3,
    ProductList4,
    Step,
  },
  data(){
    return {
      loading: true,
      fields: [],
      banners: [],
      currency: '',
    }
  },
  computed:{
    themes(){
      return this.$parent.themes
    }
  },
  created() {
    this.$parent.getThemes()
      this.currency = this.$parent.currency
      this.$http
        .get('banners')
        .then(response => (
          this.banners = response.data
          ))
        .catch(error => console.log(error))
  },
  watch: {
    themes(){
      this.showThemes()
    }
  },
  methods:{
    showThemes(){
      for (var i = 0; i < this.themes.length; i++){
        let theme = this.themes[i]
        switch (theme.components.name) {
          case 'section-title':
            this.fields.push({
              section : SectionTitle,
              name: 'section-title',
              box: (this.themes[i+1].components.name != 'product-list1'),
              data: theme.data,
            })
            break;
          case 'product-list1':
            this.fields.push({
              section :ProductList1,
              name: 'product-list1',
              products: theme.products
            })
            break;
          case 'product-list2':
            this.fields.push({
              section :ProductList2,
              name: 'product-list2',
              products: theme.products
            })
            break;
          case 'product-list3':
            this.fields.push({
              section :ProductList3,
              name: 'product-list3',
              products: theme.products
            })
            break;
          case 'product-list4':
            this.fields.push({
              section :ProductList4,
              name: 'product-list4',
              products: theme.products
            })
            break;
          case 'step':
            this.fields.push({
              section :Step,
              name: 'step',
              data: theme.data,
            })
            break;
        }
      }
    }
  }
}
</script>
